// Entities
import type {
  CottageContactPagePricesDates,
  CottageContactPagePricesPeople,
  CottageContactPagePricesResponse,
} from '../entities/CottageContactPagePrices'
import type { CottageContactPage } from '../entities/CottageContactPage'

// Endpoints
import getPrice from '~~/modules/api/rurality/v3/cottages/price'
import { type paramsType } from '~~/modules/api/rurality/v3/cottages/price/paramsSchema'

type responseType = CottageContactPagePricesResponse | null

export function useCottageContactPagePrices() {
  async function getPricesData(params: {
    cottageContactPage: Pick<CottageContactPage, 'id'>
    dates: CottageContactPagePricesDates
    people: CottageContactPagePricesPeople | null
  }): Promise<responseType> {
    const responseCottagePage: responseType = {
      label: null,
      value: null,
      message: null,
    }
    const startString = toRuralityDate().apiDate(params.dates.start as Date)
    const endString = toRuralityDate().apiDate(params.dates.end as Date)

    const queryParams: paramsType = {
      id: params.cottageContactPage.id,
      numPeople: params.people,
      dateIn: startString,
      dateOut: endString,
    }

    const contactEmailResponse = await getPrice(queryParams)

    if (contactEmailResponse?.success) {
      const fetchData = contactEmailResponse.success.data

      if (fetchData && fetchData.price !== null && fetchData.type !== null) {
        if (fetchData.type) {
          responseCottagePage.value = fetchData.price.amount

          if (fetchData.type === 'exact') {
            responseCottagePage.label = t('views.cottage-contact.price.total')
          } else if (fetchData.type === 'from') {
            responseCottagePage.label = t('views.cottage-contact.price.from')
          }
        }
      } else if (fetchData.price === null && fetchData.type === null) {
        responseCottagePage.message = t(
          'views.cottage-contact.price.emptyMessage',
        )
      }
    } else if (contactEmailResponse.error) {
      responseCottagePage.message = t(
        'views.cottage-contact.price.errorMessage',
      )
    }

    return responseCottagePage
  }

  return {
    getPricesData,
  }
}
